import { IIdItemInfo, INamedItemInfo, ILuidItemInfo } from './resourceInfoParts';

// Strings match those returned from server
export enum LocationTypes {
  Project = 'PROJECT',
  PersonalSpace = 'PERSONAL_SPACE',
  Unknown = 'UNKNOWN'
}

export interface ILocationInfo extends IIdItemInfo, INamedItemInfo, ILuidItemInfo{
  type: LocationTypes;
}
